import { apiSlice } from "../apiSlice";

export const tasksApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => "/tasks",
    }),
    getTask: builder.query({
      query: (id) => `/tasks/${id}`,
      providesTags: (result, error, arg) => [{ type: "task", id: arg }],
    }),
    addTask: builder.mutation({
      query: (data) => ({
        url: "/tasks",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const task = await queryFulfilled;

          if (task?.data?.id) {
            dispatch(
              apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
                // Update the relevant task in the tasks array
                draft.push(task?.data);

                return draft;
              })
            );
          }
        } catch {}
      },
    }),
    editTask: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const task = await queryFulfilled;

          if (task?.data?.id) {
            dispatch(
              apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
                // Update the relevant task in the tasks array
                const taskIndex = JSON.stringify(
                  // eslint-disable-next-line
                  draft.findIndex((task) => task.id == arg?.id)
                );

                Object.assign(draft[taskIndex], task?.data);

                return draft;
              })
            );
          }
        } catch {}
      },
      invalidatesTags: (result, error, arg) => [{ type: "task", id: arg.id }],
    }),
    deleteTask: builder.mutation({
      query: (id) => ({
        url: `/tasks/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update start
        const pathResult = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            // Update the relevant task in the tasks array
            // eslint-disable-next-line
            const taskIndex = JSON.stringify(
              // eslint-disable-next-line
              draft.findIndex((task) => task.id == arg)
            );

            // eslint-disable-next-line
            return draft.filter((task) => task.id != arg);
          })
        );
        // optimistic cache update end
        try {
          await queryFulfilled;
        } catch {
          pathResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetTasksQuery,
  useGetTaskQuery,
  useAddTaskMutation,
  useEditTaskMutation,
  useDeleteTaskMutation,
} = tasksApi;
